module.exports = __webpack_public_path__ + "04_glasses_black.cb306586.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer4/04_glasses_black.png
// module id = Enx5
// module chunks = 0